import { MaterialMatcher } from '../../matcher/material-matcher'
import { SerialNumberSpec } from '../serial-number-spec'

export class BatchTracingSpec {
  public id: string

  constructor(
    public name: string,
    public serialNumber: SerialNumberSpec,
    public vendors: string[],
    public matcher: MaterialMatcher
  ) {}
}
